import React from "react";
import queryString from "query-string";

const SafeZones = () => {
  const { safezones } = queryString.parse(location.search);

  if (!safezones) {
    return null;
  }

  const sharedStyles = {
    backgroundColor: "deeppink",
    opacity: 0.3,
    position: "fixed",
    zIndex: 9999,
  };

  return (
    <React.Fragment>
      <div
        style={{ ...sharedStyles, top: 0, left: 0, right: 0, height: "5rem" }}
      />
      <div
        style={{
          ...sharedStyles,
          bottom: 0,
          left: 0,
          right: 0,
          height: "5rem",
        }}
      />
    </React.Fragment>
  );
};

export default SafeZones;
